import React from 'react';
import { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';

export const IconAgain = ({ classProps }: PropsWithClassProps) => {
  const svgStyle = twMerge('w-4 h-4', classProps?.root);
  return (
    <svg className={svgStyle} viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4010_27358)">
        <path
          d="M9.03533 0C6.98586 0 5.02002 0.774092 3.56812 2.15292C2.11663 3.53158 1.29767 5.40241 1.29074 7.35547H0L1.91033 9.79091L3.76893 7.35547H2.58148C2.58739 5.93313 3.11046 4.55666 4.06167 3.46059C5.01287 2.36445 6.33344 1.61629 7.79854 1.34379C9.26346 1.07116 10.7824 1.29094 12.0963 1.96565C13.4104 2.64021 14.4384 3.72813 15.0054 5.04395C15.5723 6.35973 15.643 7.82217 15.2057 9.18202C14.7682 10.5419 13.8496 11.7153 12.6063 12.5023C11.363 13.2894 9.87187 13.6414 8.38671 13.4985C6.90162 13.3556 5.51451 12.7265 4.46138 11.7185L3.55166 12.5907C4.75582 13.7417 6.32502 14.4816 8.01578 14.6957C9.70643 14.9097 11.4239 14.586 12.9018 13.7747C14.3797 12.9636 15.5351 11.7101 16.1889 10.2091C16.8426 8.70801 16.9581 7.04326 16.5175 5.47329C16.0767 3.90325 15.1044 2.51567 13.7516 1.52604C12.3987 0.536421 10.7408 7.0438e-05 9.03522 0.000211009L9.03533 0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4010_27358">
          <rect width="17" height="15" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
